import { useState } from 'react'
import emailjs from 'emailjs-com';
import './Form_styles.css'
import thunder from '../../assets/form/thunder_form.svg';
import { useTranslation } from "react-i18next";



function Form() {
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);
  const [sentError, setSentError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    message: ''
  });
  const [errors, setErrors] = useState({
    user_name: '',
    user_email: '',
    message: ''
  });

  // Función para manejar el cambio en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Función para validar el formulario
  const validateForm = () => {
    const newErrors = {};

    if (!formData.user_name) {
      newErrors.user_name = t("form.error_name_required");
    }

    if (!formData.user_email) {
      newErrors.user_email = t("form.error_email_required");
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.user_email)) {
      newErrors.user_email = t("form.error_email_invalid");
    }

    if (!formData.message) {
      newErrors.message = t("form.error_message_required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // No enviamos el formulario si hay errores

    setIsSending(true);
    emailjs.sendForm('service_3krmmjz', 'template_almqiqj', e.target, 'o92BRDiTdMDfQbRG5')
      .then((result) => {
        document.getElementById("form_sent").classList.add("fade-out");
        setSent(true);
        document.getElementById("message_sent").classList.add("fade-in");
        e.target.reset();
        setIsSending(false);
        showForm();
      }, (error) => {
        console.log(error.text);
        document.getElementById("form_sent").classList.add("fade-out");
        setSent(true);
        setSentError(true)
        document.getElementById("message_sent_error").classList.add("fade-in");
      });
  };

  const showForm = () => {
    setTimeout(function () {
      document.getElementById("message_sent").classList.add("fade-out");
      setSent(false);
      document.getElementById("form_sent").classList.add("fade-in");
    }, 5000);
  };

  return (
    <div className="form_container" id="contact">
      <img src={thunder} alt="thunder" className="thunder-form" />
      <h1 className="title-form">{t("form.title")}</h1>
      {!sent ? (
        <form className="contact-form" onSubmit={sendEmail} id="form_sent" noValidate>
          <div className="input_group">
            <div className='input_wrapper'>
              <input
                type="text"
                name="user_name"
                placeholder={t("form.input_name")}
                value={formData.user_name}
                onChange={handleChange}
              />
              {errors.user_name && <p className="error-text">{errors.user_name}</p>}
            </div>
            <div className='input_wrapper'>
              <input
                type="email"
                name="user_email"
                placeholder={t("form.input_email")}
                value={formData.user_email}
                onChange={handleChange}
              />
              {errors.user_email && <p className="error-text">{errors.user_email}</p>}
            </div>
          </div>
          <textarea
            name="message"
            placeholder={t("form.message")}
            value={formData.message}
            onChange={handleChange}
          />
          {errors.message && <p className="error-text">{errors.message}</p>}
          <input
            className="btn-form"
            type="submit"
            value={isSending ? t("form.buttonSending") : t("form.button")}
            disabled={isSending}
          />
        </form>
      ) : (
        <>
          {sentError ?
            <h1 id="message_sent_error" className="confirm_message">{t("form.message_sent_error")}</h1>
            :
            <h1 id="message_sent" className="confirm_message">{t("form.message_sent")}</h1>
          }
        </>
      )}
    </div>
  );
}

// function Form() {
//   const { t } = useTranslation();
//   const [sent, setSent] = useState(false)
//   const [isSending, setIsSending] = useState(false)

//   function sendEmail(e) {
//     setIsSending(true)
//     e.preventDefault();
//     emailjs.sendForm('service_3krmmjz', 'template_almqiqj', e.target, 'o92BRDiTdMDfQbRG5')
//       .then((result) => {
//         document.getElementById("form_sent").classList.add("fade-out")
//         setSent(true)
//         document.getElementById("message_sent").classList.add("fade-in")
//         e.target.reset();
//         setIsSending(false)
//         showForm()
//       }, (error) => {
//         console.log(error.text);
//       });

//   }

//   function showForm() {
//     setTimeout(function () {
//       document.getElementById("message_sent").classList.add("fade-out")
//       setSent(false)
//       document.getElementById("form_sent").classList.add("fade-in")
//     }, 5000)
//   }

//   return (
//     <div className="form_container" id="contact">
//       <img src={thunder} alt="thunder" className="thunder-form" />
//       <h1 className="title-form">{t("form.title")}</h1>
//       {!sent ?
//         <form className="contact-form" onSubmit={sendEmail} id="form_sent">
//           <div className="input_group">
//             <input type="text" name="user_name" placeholder={t("form.input_name")} />
//             <input type="email" name="user_email" placeholder={t("form.input_email")} />
//           </div>
//           <textarea name="message" placeholder={t("form.message")} />
//           <input className="btn-form" type="submit" value={isSending ? t("form.buttonSending") : t("form.button")} disabled={isSending ? true : false} />
//         </form>
//         :
//         <h1 id="message_sent" className="confirm_message">{t("form.message_sent")}</h1>
//       }
//     </div>
//   )
// }

export default Form
